import MarketsPull from './markets-pull';
export default class Pull {
    constructor(option) {
        this.pullInstance = new MarketsPull(option);
    }
    // to make this is async method then it is same as stream
    async connect() {
        return this.pullInstance;
    }
}
